// extracted by mini-css-extract-plugin
export var blink = "_97-2";
export var cursor = "_97-1";
export var reactMarkdown = "_97-3";
export var streamingText = "_97-0";